/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext } from 'react'
import { UseFieldArrayAppend, UseFieldArrayRemove, UseFieldArrayUpdate } from 'react-hook-form'

import { SubEvents, Sessions } from '../../../../types'
import { ModifySubEventsSchema } from '../../../events/Events.schema'

export interface Context {
  subEventsFields: [number, SubEvents][]
  appendSubEvent: UseFieldArrayAppend<ModifySubEventsSchema, 'subEvents'>
  removeSubEvent: UseFieldArrayRemove
  updateSubEvent: UseFieldArrayUpdate<ModifySubEventsSchema, 'subEvents'>
  sessionsFields: [number, Sessions][]
  appendSession: UseFieldArrayAppend<ModifySubEventsSchema, 'sessions'>
  removeSession: UseFieldArrayRemove
  updateSession: UseFieldArrayUpdate<ModifySubEventsSchema, 'sessions'>
  eventStart: string | undefined
  eventEnd: string | undefined
  eventLocation: number | null | undefined
  showSearch: boolean
  setShowSearch: (showSearch: boolean) => void
}

export const SubEventsStep2Context = createContext<Context>({
  subEventsFields: [],
  appendSubEvent: () => {},
  removeSubEvent: () => {},
  updateSubEvent: () => {},
  sessionsFields: [],
  appendSession: () => {},
  removeSession: () => {},
  updateSession: () => {},
  eventStart: undefined,
  eventEnd: undefined,
  eventLocation: undefined,
  showSearch: false,
  setShowSearch: () => {},
})
